<app-dashboard-box icon="file_save"
                   [title]="'dialogs.report.title' | translateSafe"
                   buttonIconName="assignment_add"
                   [buttonLabel]="'common.actions.create-report' | translateSafe"
                   (buttonClick)="openCreateDialog()">

  <app-table [tableRows]="reportFiles"
             [tableConfig]="reportFilesTableConfig"
             [loading]="loading">

    <ng-template #topRow let-colspan>
      @for (status of activeReportStatuses; track status.id) {
        <tr class="report-progress-row"
            [class.is-completed]="status.step === 'COMPLETED'"
            [class.is-failed]="status.step === 'FAILED'">
          <td [attr.colspan]="colspan">
            <div class="report-progress-container">
              <div class="report-progress-info">
                <!-- Dynamisches Icon je nach Status -->
                @if (status.step === 'COMPLETED') {
                  <span class="material-symbols-rounded success-icon">check_circle</span>
                } @else if (status.step === 'FAILED') {
                  <span class="material-symbols-rounded error-icon">error</span>
                } @else {
                  <span class="material-symbols-rounded spin-icon">sync</span>
                }

                <span class="report-progress-message">
                  {{ (status.message || 'common.messages.report.generating-report') | translateSafe }}
                </span>

                <span class="report-progress-percent">
                  {{ status.progress }}%
                </span>
              </div>

              <!-- Fortschrittsbalken -->
              <div class="progress-track">
                <div class="progress-bar"
                     [class.success]="status.step === 'COMPLETED'"
                     [class.failed]="status.step === 'FAILED'"
                     [style.width.%]="status.progress">
                </div>
              </div>
            </div>
          </td>
        </tr>
      }
    </ng-template>
  </app-table>

</app-dashboard-box>

<app-dialog-base [class.open]="isCreateReportDialogOpen"
                 iconLeft="description"
                 [buttonAction]="closeCreateDialog"
                 [title]="reportCreateTitle">

  <app-report-create [preset]="reportCreatePreset"
                     (close)="closeCreateDialog()" />
</app-dialog-base>


<app-dialog-base [class.open]="isReportPreviewOpen"
                 (outSideClick)="closeReportPreviewDialog()"
                 iconLeft="description"
                 [buttonAction]="closeReportPreviewDialog"
                 [title]="reportPreviewTitle">

  @if (reportPreviewUrl) {
    <iframe
      class="report-preview-frame"
      [src]="reportPreviewUrl">
    </iframe>
  }

</app-dialog-base>